module.exports = __webpack_public_path__ + "static/media/ic-close.dd73ef47.svg";